export default {
	section_banner: {
		main_title: {
			one: 'Cookies',
		},
		sub_title: {
			one: 'Usage',
			two: 'Policy',
		},
	},

	cookies_inn: {
		label: 'JPWorldPay',
		title: {
			one: 'Cookies Usage Policy',
		},
		paragraph:
			'JPWorldPay uses cookies to anonymously collect search information from website users to obtain sources and other statistics. Cookies are tiny text files on your computers hard disk, for example, for recording the process of purchasing a product, search propensity, activity, & so on.',
	},

	cookies_mid: {
		title: 'In particular, it is used as follows:',
		paragraph: {
			one: 'Google Analytics. Google can use this information to improve its services and provide services to third parties.',
			two: 'All information can be accessed via the following link.',
		},
		cta_button: {
			one: 'Protect Data',
			two: 'Analytics Blocking Browser Add-on',
		},
		para: {
			one: 'The tool does not collect your name, address, and access information. The information about users collected is related to, for example, the number of access sites, the language of use, the city displayed by the user IP, the number of visitors, the number of revisits, the time of access, the browser, operator, or 	terminal type used. The above information is used to identify new requirements and to provide better website service to users through evaluation of improvement efforts.',
			two: 'Cookies used on social networks. This website has a social network button installed to allow users to share their content of interest with social groups. Cookies stored through social networks prevent the inconvenience of re-entering personal information in sharing the above content.',
			three:
				'Tools options in the web browser installed on your computer allow you to allow/disallow all cookies, delete them, or go through verification whenever cookies are saved.',
		},
		sub_title: {
			one: 'You can find functional information for each web',
			two: 'browser you use at the link below:',
		},
		last_cta_button: {
			one: 'Firefox',
			two: 'Chrome',
			three: 'Safari',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
